import { ToastOptions } from 'react-toastify'

export const DEFAULT_TOAST_OPTIONS: ToastOptions = {
    position: 'bottom-center',
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
}
